// extracted by mini-css-extract-plugin
export var menuIcon = "_jv-0";
export var menuIconInline = "_jv-1";